module.exports = __webpack_public_path__ + "img/introduce06.4f431baf.png";